export const PLAY_VIDEO = 'play-video';
